import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button, useMediaQueryContext } from '@fourthwall/components'
import { reverse, routing } from '@utils/routing'

import { useOfferCombinedCreationMutation } from './queries/useOfferCombinedCreationMutation'

type CreateCombinedProductButtonProps = {
  onSuccess: () => void
}

export const CreateCombinedProductButton = ({ onSuccess }: CreateCombinedProductButtonProps) => {
  const navigate = useNavigate()
  const { tablet } = useMediaQueryContext()

  const { offerCombinedCreationMutation } = useOfferCombinedCreationMutation({
    onSuccess: ({ id }) => {
      onSuccess()

      navigate(
        `${reverse(routing.products.combined.combinedId.self, { combinedId: id })}${location.search}`,
      )
    },
  })

  return (
    <Button
      fullWidth={!tablet}
      label="Combine product listings"
      loading={offerCombinedCreationMutation.isLoading || offerCombinedCreationMutation.isSuccess}
      disabled={offerCombinedCreationMutation.isLoading || offerCombinedCreationMutation.isSuccess}
      size="xsmall"
      onClick={async () => {
        await offerCombinedCreationMutation.mutateAsync([])
      }}
    />
  )
}
